import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { TriviaFormHeader } from './Header';
import { TriviaFormContent } from './Content';

export class TriviaFormComponent extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    points: PropTypes.number,
    choices: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
      }),
    ),
    timeRemainingToAnswer: PropTypes.number,
    answerTimeout: PropTypes.number,
    selectedValue: PropTypes.string,
    disabled: PropTypes.bool,
    handleChoiceSelect: PropTypes.func.isRequired,
  };

  static defaultProps = {
    title: '',
    points: 0,
    choices: [],
    answerTimeout: 10000,
    timeRemainingToAnswer: 10000,
    selectedValue: null,
    disabled: false,
  };

  render() {
    const {
      title,
      points,
      choices,
      timeRemainingToAnswer,
      answerTimeout,
      selectedValue,
      disabled,
      handleChoiceSelect,
      ...props
    } = this.props;

    return (
      <Fragment>
        <TriviaFormHeader
          title={title}
          timeRemainingToAnswer={timeRemainingToAnswer}
          answerTimeout={answerTimeout}
          {...props}
        />
        <TriviaFormContent
          title={title}
          points={points}
          choices={choices}
          disabled={disabled}
          selectedValue={selectedValue}
          handleChoiceSelect={handleChoiceSelect}
        />
      </Fragment>
    );
  }
}
